module.exports = __webpack_public_path__ + "static/img/product_images_06_h5_zh.19e0a1a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_images_06_h5_zh.png
// module id = 4PtK
// module chunks = 34